import { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import { getViewLabel } from './adminViewLabels';

const AdminLayout = ({ children, activeView, setActiveView, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSetView = (view) => {
    setActiveView(view);
    setSidebarOpen(false);
  };

  return (
    <>
      <div className="admin-layout">
        <div
          className={`admin-sidebar-overlay ${sidebarOpen ? 'open' : ''}`}
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
        <AdminSidebar
          activeView={activeView}
          setActiveView={handleSetView}
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        <div className="admin-main">
          <AdminHeader
            onLogout={onLogout}
            sectionTitle={getViewLabel(activeView)}
            onMenuClick={() => setSidebarOpen((o) => !o)}
          />
          <main className="admin-content">{children}</main>
        </div>
      </div>
      <style>{`
        .admin-layout {
          display: flex;
          min-height: 100vh;
          background: #f4f6f8;
        }
        .admin-main {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-width: 0;
        }
        .admin-content {
          padding: 12px;
          flex: 1;
          overflow-x: hidden;
        }
        @media (min-width: 480px) {
          .admin-content { padding: 16px; }
        }
        @media (min-width: 769px) {
          .admin-content { padding: 30px; }
        }
        .admin-sidebar-overlay {
          display: none;
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.4);
          z-index: 40;
        }
        @media (max-width: 768px) {
          .admin-sidebar-overlay {
            display: block;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.2s ease;
          }
          .admin-sidebar-overlay.open {
            opacity: 1;
            pointer-events: auto;
          }
        }
      `}</style>
    </>
  );
};

export default AdminLayout;
